
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fn7j_d5rlr_9",
  "styled-box": "awsui_styled-box_1fn7j_d5rlr_16",
  "styled-box-checked": "awsui_styled-box-checked_1fn7j_d5rlr_32",
  "styled-box-indeterminate": "awsui_styled-box-indeterminate_1fn7j_d5rlr_32",
  "styled-box-disabled": "awsui_styled-box-disabled_1fn7j_d5rlr_36",
  "styled-box-readonly": "awsui_styled-box-readonly_1fn7j_d5rlr_36",
  "styled-line": "awsui_styled-line_1fn7j_d5rlr_40",
  "styled-line-disabled": "awsui_styled-line-disabled_1fn7j_d5rlr_45",
  "styled-line-readonly": "awsui_styled-line-readonly_1fn7j_d5rlr_48",
  "awsui-checkbox-draw": "awsui_awsui-checkbox-draw_1fn7j_d5rlr_1"
};
  